'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import SnowflakeEditor from 'reporting-enablement/components/reportEditors/SnowflakeEditor';
import { isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const SnowflakeFiltersControl = ({
  report,
  updateContext
}) => {
  const originalStagedFilters = report.getIn(['reportDefinition', 'filtering', 'stagedFilters'], List());
  return /*#__PURE__*/_jsx(SnowflakeEditor, {
    report: report,
    onChange: newReport => {
      updateContext({
        relationalCustomFilters: ImmutableMap({
          filtering: newReport.getIn(['reportDefinition', 'filtering']).set('stagedFilters', originalStagedFilters),
          eventDateInterval: newReport.getIn(['reportDefinition', 'eventDateInterval'])
        })
      }, report);
    }
  });
};
SnowflakeFiltersControl.isUsableForReport = ({
  report
}) => {
  return isRelationalReport(report);
};
export default SnowflakeFiltersControl;